const CheckedCheckboxIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <rect x="10" y="10" width="20" height="20" rx="2" fill="#0AC4B2" />
      <path
        d="M13.6152 19.383L17.3035 25L25.9094 14"
        stroke="white"
        strokeWidth="1.77941"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CheckedCheckboxIcon;
